import { Alert, Button, Form, Tab, Tabs } from "react-bootstrap";
import { Modal, MuniSpinner2 } from "../../../components";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import { useActasStore } from "../../../store/actasStore";
import useActas from "../../../api/actas";
import { useForm } from "react-hook-form";
import { useActaDetalleStore } from "../../../store/actaDetalleStore";

const ModalCompletarDatos = ({ modals, handlerModal, actaDetalle,setRefetch }) => {

    const { alertas } = useActaDetalleStore();
    const { loads } = useGeneralAppStore();
    const { completarDatosDomicilio ,marcarActaComoAprobadoParaImprimir} = useActas();
    // const { acta } = actaDetalle;
    const { acta } = useActaDetalleStore();

    const { register, handleSubmit, watch } = useForm({
        // defaultValues: {
        //     direccion_titular: acta?.direccion_titular,
        //     provincia: acta?.provincia,
        //     localidad: acta?.localidad,
        //     codigo_postal: acta?.codigo_postal
        // }
    })

    const onSubmit = (data) => {
        // console.log(data)
        // completarDatosDomicilio({ ...data, numero_infraccion: acta?.numero_infraccion, id: acta?.id, is_edit: false },setRefetch);
        marcarActaComoAprobadoParaImprimir({ ...data, numero_infraccion: acta?.numero_infraccion, id_acta: acta?.id, is_edit: false },setRefetch);
    }

    return (
        <>
            <Modal
                show={modals.includes('completar_datos')}
                size={"md"}
                onHide={() => handlerModal({ modal: false, modalName: "completar_datos" })}
                title={() => "Completar datos domicilio"}
            >                
                <div className="position-relative">
                    {
                        loads.includes('completar_datos') &&
                        <div className="position-absolute h-100 w-100 d-flex justify-content-center align-items-center" style={{ backgroundColor: "rgba(255,255,255,0.7)" }}>
                            <MuniSpinner2 />
                        </div>
                    }
                    <Form onSubmit={handleSubmit(onSubmit)} className="d-flex flex-column gap-4 ">

                        {
                            alertas?.some((alerta) => alerta.label == "documento_titular") &&
                            <Form.Group>
                                <Form.Label className="m-0">Documento</Form.Label>
                                <Form.Control placeholder="Documento del titular..." {...register('documento_titular')} />
                            </Form.Group>
                        }
                        {
                            alertas?.some((alerta) => alerta.label == "direccion_titular") &&
                            <Form.Group>
                                <Form.Label className="m-0">Dirección</Form.Label>
                                <Form.Control placeholder="Dirección del titular..." {...register('direccion_titular')} />
                            </Form.Group>
                        }

                        {
                            alertas?.some((alerta) => alerta.label == "provincia") &&
                            <Form.Group>
                                <Form.Label className="m-0">Provincia</Form.Label>
                                <Form.Control placeholder="Provincia..."  {...register('provincia')} />
                            </Form.Group>
                        }


                        {
                            alertas?.some((alerta) => alerta.label == "localidad") &&
                            <Form.Group>
                                <Form.Label className="m-0">Localidad</Form.Label>
                                <Form.Control placeholder="Localidad..." {...register('localidad')} />
                            </Form.Group>

                        }

                        {
                            alertas?.some((alerta) => alerta.label == "codigo_postal") &&
                            <Form.Group>
                                <Form.Label className="m-0">Código postal</Form.Label>
                                <Form.Control placeholder="Código postal..." type="number" {...register('codigo_postal')} />
                            </Form.Group>
                        }

                        {
                            (watch('direccion_titular') == "" || watch('provincia') == "" || watch('localidad') == "" || watch('codigo_postal') == "") ?
                                <div className="d-flex justify-content-center" style={{ height: "20px" }}>
                                    <span className="text-danger fw-medium">Debe completar todo los campos</span>
                                </div>
                                :
                                <div className="d-flex justify-content-center" style={{ height: "20px" }} />

                        }
                        
                        <Button type="submit">Enviar</Button>
                    </Form>
                </div>

            </Modal>
        </>
    );
}
export default ModalCompletarDatos;